import { MapPin } from 'lucide-react';
import { profile } from '@/data/profile';
import { Container, SectionHeading } from '@/components/common/SectionHeading';
import styles from './About.module.css';

export function About() {
  return (
    <section id="about" className="section" aria-labelledby="about-title">
      <Container>
        <SectionHeading
          id="about-title"
          eyebrow="About"
          title="Engineering with clarity and follow-through"
          description="A concise look at how I work and where I focus."
        />
        <div className={styles.grid}>
          <div className={styles.copy}>
            {profile.about.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          <aside className={styles.meta}>
            <div className={styles.metaCard}>
              <p className={styles.metaLabel}>Location</p>
              <p className={styles.metaValue}>
                <MapPin size={16} aria-hidden="true" />
                {profile.location}
              </p>
            </div>
            <div className={styles.metaCard}>
              <p className={styles.metaLabel}>Email</p>
              <a className={styles.metaValue} href={`mailto:${profile.email}`}>
                {profile.email}
              </a>
            </div>
            <div className={styles.metaCard}>
              <p className={styles.metaLabel}>Currently</p>
              <p className={styles.metaValue}>Software Engineer at ARD Grup</p>
            </div>
          </aside>
        </div>
      </Container>
    </section>
  );
}
